export default __webpack_public_path__ + "static/media/groundPart9.1a64c608.webp";